<template>
	<section class="col-xs-12 block obj-cont corte ivitamos">
		<img src="" alt="" class="obj-img">
		<div class="container">
			<div class="row flex-centermid">
				<h2> </h2>
				<a href="" class="btn gradient">

				</a>
			</div>
		</div>
	</section>
</template>

<script>
export default {

	props:[
		'post_id',
	],
	mounted: function() {
		const vm = this;
		vm.getImgLink();
	},

	data() {
		return {
			loaded: 'false'
		};
	},

	methods: {
		getImgLink: function() {
			const vm = this;
			vm.loaded = 'false';
			vm.$http.get( 'wp/v2/portada/'+vm.post_id.id)
				.then( ( res ) => {
					vm.slider = res.data;
					vm.loaded = 'true';
						jQuery('section.ivitamos img.obj-img').attr('src',vm.slider.better_featured_image.media_details.sizes['1440x446'].source_url);
						jQuery('section.ivitamos div.row h2').html(vm.slider.excerpt.rendered);
						if(vm.slider.post_meta_fields.enlace!==undefined){
							jQuery('section.ivitamos div.row a').html(vm.slider.post_meta_fields.texto_enlace);
							jQuery('section.ivitamos div.row a').attr('href',vm.slider.post_meta_fields.enlace);
						}
					vm.$nextTick(function(){
						init_attach();
					});
				} )
				.catch( ( res ) => {
					console.log( `Something went wrong : ${ res }` );
				} );
		},
	}
};
</script>



// WEBPACK FOOTER //
// img_linkportada.vue?7f4658cc